import { useSelector } from 'react-redux';
import { selectUserInfo } from 'features/user/userSlice';

export const useUserLanguages = () => {
  const userInfo = useSelector(selectUserInfo);
  const primaryLanguage = userInfo?.business?.primaryLanguage?.toLowerCase() || 'english';
  const secondaryLanguage = userInfo?.business?.secondaryLanguage?.toLowerCase() || 'arabic';

  // Language display names mapping
  const languageNames: { [key: string]: string } = {
    english: 'English',
    arabic: 'Arabic',
    urdu: 'Urdu',
    french: 'French',
  };

  return {
    primaryLanguage,
    secondaryLanguage,
    primaryLanguageName: languageNames[primaryLanguage] || primaryLanguage,
    secondaryLanguageName: languageNames[secondaryLanguage] || secondaryLanguage,
  };
};

